export const SLogoNameImage = {
  height: 42,
  width: 102,
  maxHeight: { xs: 22, md: 42 },
  maxWidth: { xs: 82, md: 102 },
};
